/** Current user/tenant, stamped onto every span and used to template rids. */
let userId: string | null = null;
let subdomain: string | null = null;
let instanceName: string | null = null;

export const setSpanIdentity = (
    id: string | null,
    tenant: string | null,
    name: string | null
): void => {
    userId = id;
    subdomain = tenant;
    instanceName = name;
};

export const currentUserId = (): string | null => userId;
export const currentSubdomain = (): string | null => subdomain;
export const currentInstanceName = (): string | null => instanceName;
